import { Select } from "antd"
import ArrowBackButton from "../../../../components/button/ArrowBackButton"
import { useParams } from "react-router-dom"
import { useEffect, useState } from "react"
import useGroupBuForm from "./useGroupBuForm"
import ActionButtonGradient from "../../../../components/button/ActionButtonGradient"

const GroupBusinessUnitForm = () => {
    const params = useParams()
    const [isUpdate, setIsUpdate] = useState(false)
    const {
        payload,
        postGbuForm,
        putGbuForm,
        onChangeHandler,
        getGbuForm,
        status,
        isSaving,
        handleSelectStatus
    } = useGroupBuForm()

    useEffect(() => {
        if (params.gbu_id) {
            setIsUpdate(true)
            getGbuForm(params.gbu_id)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.gbu_id])

    return(
        <div className="container-fluid justify-content-center" style={{ 
            maxWidth: '1200px', 
            margin: '0 auto',
            width: '100%',
        }}>
            <div style={{ marginBottom: '24px' }}>
                <ArrowBackButton 
                    title={isUpdate ? "Edit Group Business Unit" : "Create Group Business Unit"} 
                    isTwoSection={true}
                />
            </div>
            
            <div style={{
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                padding: '24px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                border: '1px solid #f0f0f0'
            }}>
                <h5 style={{ 
                    margin: 0,
                    marginBottom: '24px',
                    fontWeight: 600,
                    color: '#1a1a1a',
                    fontSize: '18px'
                }}>
                    {isUpdate ? "Edit Group Business Unit" : "Group Business Unit Information"}
                </h5>

                <form onSubmit={(e) => {
                    isUpdate ? putGbuForm(e): postGbuForm(e)
                }}>
                    <div style={{
                        padding: '20px',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '8px',
                        border: '1px solid #e5e7eb',
                        marginBottom: '24px'
                    }}>
                        <div className="mb-4">
                            <label htmlFor="GroupName" style={{ 
                                fontWeight: '600', 
                                color: '#374151', 
                                fontSize: '14px',
                                marginBottom: '8px',
                                display: 'block'
                            }}>
                                Group Business Unit Name <span style={{color: 'red'}}>*</span>
                            </label>
                            <input 
                                required
                                type="text" 
                                name="GroupName"
                                className="form-control" 
                                id="GroupName" 
                                placeholder="Enter Group Business Unit Name" 
                                value={payload.GroupName}
                                onChange={(e) => onChangeHandler(e)}
                                style={{
                                    padding: '8px 12px',
                                    borderRadius: '6px',
                                    border: '1px solid #d1d5db',
                                    fontSize: '16px'
                                }}
                            />
                        </div>

                        <div className="mb-0">
                            <label htmlFor="Status" style={{ 
                                fontWeight: '600', 
                                color: '#374151', 
                                fontSize: '14px',
                                marginBottom: '8px',
                                display: 'block'
                            }}>
                                Status <span style={{color: 'red'}}>*</span>
                            </label>
                            <Select
                                required
                                allowClear
                                size="large"
                                style={{
                                    width: '100%'
                                }}
                                showSearch="true"
                                name="Status"
                                options={status}
                                placeholder="Enter Status"
                                onChange={handleSelectStatus}
                                value={payload.Status}
                                fontSize="16px"
                            />
                        </div>
                    </div>

                    <div className="d-flex justify-content-end">
                        { isUpdate ? 
                            <ActionButtonGradient
                                type="submit"
                                variant="primary"
                                disabled={isSaving}
                                children={isSaving ? "Saving..." : "Save Changes"}
                            />
                            :
                            <ActionButtonGradient
                                type="submit"
                                variant="success"
                                disabled={isSaving}
                                children={isSaving ? "Saving..." : "Save Group Business Unit"}
                            />
                        }
                    </div>
                </form>
            </div>
        </div>
    )
}

export default GroupBusinessUnitForm